import { render, staticRenderFns } from "./wangeditorExercise.vue?vue&type=template&id=86dd9d40"
import script from "./wangeditorExercise.vue?vue&type=script&lang=js"
export * from "./wangeditorExercise.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports